// app lib
import isProduction from '../../app/lib/isProduction.lib.app';

// Performance Monitoring: Capture 100% of the transactions, reduce in production!
const TRACES_SAMPLE_RATE = () => (isProduction() ? 0.1 : 1.0);

export default TRACES_SAMPLE_RATE;
